import React from 'react';
import activityPanelStore from 'shared/store/activityPanelStore';
import { ProductModal } from './ProductModal';
import { getDefaultProductConstraints } from 'types/ProductTypes';

/**
 * Container component that renders ProductModal at the top level.
 * This prevents the modal from being unmounted during responsive layout changes.
 * Should be rendered in AssistantPage or another stable parent component.
 */
export const ProductModalContainer: React.FC = () => {
  const {
    productModalOpen,
    productModalData,
    productModalOnSave,
    closeProductModal,
    constraintsPanelMode,
  } = activityPanelStore();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeProductModal();
    }
  };

  const handleSave = (data: Parameters<typeof productModalOnSave>[0]) => {
    if (productModalOnSave) {
      productModalOnSave(data);
    }
    closeProductModal();
  };

  return (
    <ProductModal
      open={productModalOpen}
      onOpenChange={handleOpenChange}
      initialData={productModalData || getDefaultProductConstraints()}
      onSave={handleSave}
      mode={constraintsPanelMode}
    />
  );
};
